import { FC } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineChevronRight } from "react-icons/hi";
import { Link, Navigate, useParams } from "react-router-dom";
import { PageLayout } from "@components";
import { integrationCatalog } from "../../integrations/catalog";
import IntegrationsSettingsContent from "./tabs/IntegrationsSettingsContent";
import ShopifyIntegrationContent from "./ShopifyIntegrationContent";

const IntegrationDetailPage: FC = () => {
  const { integrationKey } = useParams();
  const { t } = useTranslation("workspace");
  const integration =
    integrationKey === "tripletex" || integrationKey === "shopify"
      ? integrationCatalog[integrationKey]
      : undefined;

  if (!integration) return <Navigate to="/settings?tab=integrations" replace />;

  return (
    <PageLayout>
      <div className="mx-auto max-w-5xl space-y-6">
        <nav
          className="flex items-center gap-2 text-sm text-secondary"
          aria-label="Breadcrumb"
        >
          <Link
            className="hover:text-brand hover:underline"
            to="/settings?tab=integrations"
          >
            {t("settings.tabs.integrations")}
          </Link>
          <HiOutlineChevronRight className="h-4 w-4" />
          <span className="font-medium text-text">{integration.name}</span>
        </nav>

        {integrationKey === "tripletex" ? (
          <IntegrationsSettingsContent detailMode />
        ) : (
          <ShopifyIntegrationContent logoSrc={integration.logoSrc} />
        )}
      </div>
    </PageLayout>
  );
};

export default IntegrationDetailPage;
